import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import map_marker from 'map_marker.svg';
import { useInView } from 'react-intersection-observer';

export const StaticMapMarker = () => (
  <img
    data-src={map_marker}
    alt=""
    title="Map Marker"
    style={{ transform: 'translate(-50%, -100%)' }}
    className="lazyload"
  />
);

export default function StaticMap({ listings }) {
  const defaultProps = {
    center: {
      lat: 30.3935,
      lng: -86.4958,
    },
    zoom: 11,
  };

  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  return (
    <div ref={ref} style={{ width: '100%', height: '100%' }}>
      {inView && (
        <GoogleMapReact
          bootstrapURLKeys={{
            // TODO: REPLACE WITH ENV VAR
            key: 'AIzaSyATvnQePj9OTTCZJ6VkugYM8dRGFPJ5HmQ',
          }}
          defaultCenter={defaultProps.center}
          defaultZoom={defaultProps.zoom}
        >
          {listings.splice(1, 10).map(listing => (
            <StaticMapMarker
              key={listing.id}
              lat={listing.latitude}
              lng={listing.longitude}
            />
          ))}
        </GoogleMapReact>
      )}
    </div>
  );
}

StaticMap.propTypes = {
  listings: PropTypes.array,
};
